// src/pages/install-app/InstallAppDefaultSection.tsx
import React, { useEffect } from 'react';
import { ENVIRONMENT } from '../../../../env';
import {
  Title,
  Subtitle,
  InstallButton,
  InstallDescription,
} from './install.styled';
import { VSpace } from '../../../chat/settings/account/account-settings';

interface InstallAppDefaultSectionProps {
  isInstalled: boolean;
  isStandalone: boolean;
  hasInstalledRecently: boolean;
  onInstall: () => void;
}


export const InstallAppDefaultSection: React.FC<InstallAppDefaultSectionProps> = ({
  isInstalled,
  isStandalone,
  hasInstalledRecently,
  onInstall,
}) => {
  const alreadyInstalled = isInstalled || isStandalone || hasInstalledRecently;

  useEffect(() => {
    if (ENVIRONMENT === 'DEV') console.log('[PWA][InstallAppDefaultSection] props snapshot:', {
      isInstalled,
      isStandalone,
      hasInstalledRecently,
      alreadyInstalled,
      buttonLabel: alreadyInstalled ? 'Already Installed' : 'Install Now',
    });
  }, [isInstalled, isStandalone, hasInstalledRecently, alreadyInstalled]);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Title>
          Install Mailander.
        </Title>

        <VSpace $h={24} />

        <Subtitle>
          Access Mailander directly from your 
          <br /> Home Screen.
        </Subtitle>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <InstallButton onClick={onInstall}>
          {alreadyInstalled ? 'Already Installed' : 'Install Now'}
        </InstallButton>
        <InstallDescription>
          After install, open Mailander from your
          <br />
          Home screen to continue.
        </InstallDescription>
      </div>
    </div>
  );
};
